export default "__VITE_ASSET__BJldV75M__"